import { TextMessagePayloadBase } from "./text-message-payload-base";

export class CompanyDebtReminderTextMessagePayload extends TextMessagePayloadBase {
  static override $type = 'CompanyDebtReminderTextMessagePayload';

  companyName: string;
  companyACN: string;
  partner: string;
  asicContact: string;
  accountManager: string;
  billingContactFirstName: string;
  billingContactFullName: string;
  debt: string;
  dueDate: string;
  dueDateShortFormat: string;
  payUrl: string;

  constructor(data: Partial<CompanyDebtReminderTextMessagePayload> = {}) {
    super(data);
    this.companyName = data.companyName ?? '';
    this.companyACN = data.companyACN ?? '';
    this.partner = data.partner ?? '';
    this.asicContact = data.asicContact ?? '';
    this.accountManager = data.accountManager ?? '';
    this.billingContactFirstName = data.billingContactFirstName ?? '';
    this.billingContactFullName = data.billingContactFullName ?? '';
    this.debt = data.debt ?? '';
    this.dueDate = data.dueDate ?? '';
    this.dueDateShortFormat = data.dueDateShortFormat ?? '';
    this.payUrl = data.payUrl ?? '';
  }
}
